import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ToolsComponent} from './tools.component';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [ToolsComponent],
    imports: [
        CommonModule,
        TranslateModule
    ]
})
export class ToolsModule { }
